var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { childrenPropType, TSS_RED, TSS_BLUE, TSS_GREEN, TSS_ORANGE, TSS_BLACK } from 'tss-core-lib-common';
import { Icon, IMG_ICON_SUCCESS_O, IMG_ICON_WARNING_TRIANGLE } from '..';

var styles = void 0;

var Notification = function (_Component) {
  _inherits(Notification, _Component);

  function Notification() {
    _classCallCheck(this, Notification);

    return _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).apply(this, arguments));
  }

  _createClass(Notification, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.timeout && this.props.onTimeout) {
        this.timer = setTimeout(this.props.onTimeout, this.props.timeout);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          error = _props.error,
          info = _props.info,
          success = _props.success,
          warning = _props.warning;

      return React.createElement(
        'div',
        {
          className: css(styles.container, info && styles.info, success && styles.success, warning && styles.warning, error && styles.error)
        },
        React.createElement(
          'div',
          { className: css(styles.innerContent) },
          success ? React.createElement(Icon, { src: IMG_ICON_SUCCESS_O, stroke: TSS_GREEN(), className: css(styles.icon) }) : null,
          error ? React.createElement(Icon, { src: IMG_ICON_WARNING_TRIANGLE, stroke: TSS_RED(), className: css(styles.icon) }) : null,
          warning ? React.createElement(Icon, { src: IMG_ICON_WARNING_TRIANGLE, stroke: TSS_ORANGE(), className: css(styles.icon) }) : null,
          children
        )
      );
    }
  }]);

  return Notification;
}(Component);

Notification.propTypes = {
  children: childrenPropType.isRequired,
  info: PropTypes.bool,
  success: PropTypes.bool,
  error: PropTypes.bool,
  warning: PropTypes.bool,
  timeout: PropTypes.number,
  onTimeout: PropTypes.func
};
Notification.defaultProps = {
  info: false,
  success: false,
  error: false,
  warning: false,
  timeout: 0,
  onTimeout: null
};


styles = StyleSheet.create({
  container: {
    fontSize: '1.6rem',
    fontWeight: 600
  },

  innerContent: {
    padding: '1.2rem',
    display: 'flex',
    alignItems: 'center'
  },

  icon: {
    margin: '0 1.2rem 0 0'
  },

  error: {
    color: TSS_RED(),
    backgroundColor: TSS_RED(0.2)
  },

  warning: {
    color: TSS_ORANGE(),
    backgroundColor: TSS_ORANGE(0.2)
  },

  info: {
    color: TSS_BLUE(),
    backgroundColor: TSS_BLUE(0.2)
  },

  success: {
    color: TSS_BLACK(),
    backgroundColor: TSS_GREEN(0.2)
  },

  levitateInner: {
    position: 'absolute',
    top: '10rem',
    left: 0,
    width: '100vw',
    display: 'flex',
    justifyContent: 'center'
  }
});

export default Notification;